// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___tJnoa","image":"image___JZhEV","title":"title___Yplyc","desc":"desc___m7V_H"};